import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list"]
  
  connect() {
    this.generateTOC()
    this.setupSmoothScroll()
  }
  
  generateTOC() {
    // Find all H2 and H3 headings in the main content
    const article = this.element.closest('article')
    const headings = article.querySelectorAll('.prose h2, .prose h3')
    
    if (headings.length === 0) {
      // Hide TOC if no headings
      this.element.style.display = 'none'
      return
    }
    
    // Clear existing TOC
    this.listTarget.innerHTML = ''
    
    // Generate TOC items
    headings.forEach((heading, index) => {
      // Add ID to heading if not present
      if (!heading.id) {
        heading.id = `heading-${index + 1}`
      }
      
      // Create TOC item
      const li = document.createElement('li')
      const a = document.createElement('a')
      
      // Style based on heading level
      if (heading.tagName === 'H2') {
        li.className = 'mb-2'
        a.className = 'text-gray-700 hover:text-[#2E7D32] font-medium transition-colors'
      } else {
        li.className = 'ml-4 mb-1'
        a.className = 'text-gray-600 hover:text-[#2E7D32] text-sm transition-colors'
      }
      
      a.href = `#${heading.id}`
      a.textContent = heading.textContent
      a.dataset.action = 'click->toc#scrollToSection'
      
      li.appendChild(a)
      this.listTarget.appendChild(li)
    })
    
    // Show active section on scroll
    this.observeHeadings(headings)
  }
  
  scrollToSection(event) {
    event.preventDefault()
    const target = document.querySelector(event.currentTarget.getAttribute('href'))
    
    if (target) {
      const offset = 100 // Account for sticky header
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      })
    }
  }
  
  setupSmoothScroll() {
    // Add smooth scroll behavior to all anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      if (!anchor.dataset.action) {
        anchor.addEventListener('click', (e) => {
          e.preventDefault()
          const target = document.querySelector(anchor.getAttribute('href'))
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' })
          }
        })
      }
    })
  }
  
  observeHeadings(headings) {
    // Create intersection observer to highlight active section
    const options = {
      rootMargin: '-100px 0px -70% 0px',
      threshold: 0
    }
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const id = entry.target.id
        const tocLink = this.listTarget.querySelector(`a[href="#${id}"]`)
        
        if (tocLink) {
          if (entry.isIntersecting) {
            // Remove active class from all links
            this.listTarget.querySelectorAll('a').forEach(link => {
              link.classList.remove('text-[#2E7D32]', 'font-bold')
            })
            // Add active class to current link
            tocLink.classList.add('text-[#2E7D32]', 'font-bold')
          }
        }
      })
    }, options)
    
    // Observe all headings
    headings.forEach(heading => {
      observer.observe(heading)
    })
  }
}